import React, { forwardRef, useState, useRef, isValidElement } from 'react';
import ImageStyled from './bundle.esm3.js';
import { getResizedImageUrl } from '../../utils/bundle.esm4.js';
import { createBluredImageConfig } from './bundle.esm2.js';
import useIsomorphicLayoutEffect from '../../hooks/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Image = forwardRef((props, ref) => {
  const _a = props, {
    image,
    alt,
    className,
    config,
    errorImage,
    placeholder = "skeleton",
    placeholderNode,
    width,
    height
  } = _a, rest = __objRest(_a, [
    "image",
    "alt",
    "className",
    "config",
    "errorImage",
    "placeholder",
    "placeholderNode",
    "width",
    "height"
  ]);
  const { width: widthCDN, height: heightCDN } = config != null ? config : {};
  const [imgLoading, setImgLoading] = useState(true);
  const [imgError, setImgError] = useState(false);
  const internalRef = useRef(null);
  const showErrorImage = !imgLoading && (imgError || !image);
  const imgErrorURL = showErrorImage || !image ? errorImage : void 0;
  const imgUrl = getResizedImageUrl(image, config);
  const bluredImgURL = getResizedImageUrl(
    image,
    createBluredImageConfig(config)
  );
  const loadHandler = async (error) => {
    const instance = internalRef.current;
    if (instance && !error) {
      await instance.decode();
    }
    setImgLoading(false);
  };
  const imgLoadHandler = async (event) => {
    var _a2;
    loadHandler(false);
    (_a2 = rest.onLoad) == null ? void 0 : _a2.call(rest, event);
  };
  const imgErrorHandler = (event) => {
    var _a2;
    loadHandler(true);
    setImgError(true);
    (_a2 = rest.onError) == null ? void 0 : _a2.call(rest, event);
  };
  const renderPlaceholder = () => {
    if (placeholder === "none" || placeholder === "blur") {
      return null;
    }
    if (placeholder === "skeleton") {
      return /* @__PURE__ */ React.createElement("div", {
        className: "Image__placeholder loading-shine"
      });
    }
    if (isValidElement(placeholderNode)) {
      return /* @__PURE__ */ React.createElement("div", {
        className: "Image__placeholder"
      }, placeholderNode);
    }
    console.error("Cannot display this placeholder image type");
  };
  const setRef = (instance) => {
    var _a2;
    if (typeof ref === "function") {
      ref(instance);
      internalRef.current = instance;
      if ((_a2 = internalRef.current) == null ? void 0 : _a2.complete) {
        loadHandler(false);
      }
      return instance;
    }
    throw Error("setRef should never be called without a ref function");
  };
  useIsomorphicLayoutEffect(() => {
    var _a2;
    let instance = internalRef.current;
    if (!instance && typeof ref !== "function") {
      internalRef.current = (_a2 = ref == null ? void 0 : ref.current) != null ? _a2 : null;
      instance = internalRef.current;
    }
    if (!instance || !instance.complete)
      return;
    loadHandler(false);
  }, []);
  return /* @__PURE__ */ React.createElement(ImageStyled, {
    className: `Image ${className}`,
    width: width != null ? width : widthCDN,
    height: height != null ? height : heightCDN,
    isLoading: imgLoading,
    placeholder,
    bluredImgURL
  }, /* @__PURE__ */ React.createElement("img", __spreadProps(__spreadValues({
    className: "Image__img",
    decoding: "async"
  }, rest), {
    ref: typeof ref === "function" ? setRef : ref,
    src: imgErrorURL != null ? imgErrorURL : imgUrl,
    alt,
    width: width != null ? width : widthCDN,
    height: height != null ? height : heightCDN,
    onLoad: imgLoadHandler,
    onError: imgErrorHandler
  })), imgLoading ? renderPlaceholder() : null);
});
Image.defaultProps = {
  className: "",
  loading: "lazy",
  placeholder: "skeleton"
};

export { Image as default };
//# sourceMappingURL=bundle.esm.js.map
